<template>
  <div id="upAccount">
    <el-form label-width="200px"  class="demo-ruleForm upAccount-form y-m-auto" :model="upAccountForm" ref="upAccountForm" :rules="upAccountFormRules">
      <el-form-item prop="mobile" :label="upAccountInfo.flag==1?'初始绑定账户手机号':'绑定手机号'" class="phone-input">
        <el-input v-model="upAccountForm.mobile" disabled></el-input>
      </el-form-item>
      <el-form-item prop="picSmsCode" label="图片验证码" class="code-input">
        <el-input  v-model="upAccountForm.picSmsCode" :maxlength="4" placeholder="请输入图形验证码"></el-input><img class="picture-sms-code code-btn" @click="refreshPic(upAccountInfo.authCode)" alt="" :src="src"/>
      </el-form-item>
      <el-form-item prop="smsCode" label="短信验证码" class="code-input">
        <el-input  v-model="upAccountForm.smsCode" :maxlength="6" placeholder="请输入短信验证码"></el-input><el-button class="sms-code-btn code-btn" @click="sendSmsCode" :disabled="timeText >= 0">{{timeText >= 0 ? timeText + 's' : '获取验证码'}}</el-button>
        <span class="tip-style y-ml-5 y-f-l y-c-p" @click="toApply" v-if="upAccountInfo.haveNextVerifyMobileOperate">无法接收短信？</span>
      </el-form-item>
      <el-form-item label-width="0" class="form-btn">
        <el-button class="y-w-100" @click="close">取消</el-button>
        <el-button class="y-w-100" type="primary" @click="verifySmsCode">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script> 
import Cookies from 'js-cookie';
import timeText from '@/mixins/timeText';
import { 
  getImageVerifyCodeByQuicksettlementApi,//获取图形验证码
  getSmsCodeByQuicksettlementApi,//获取短信验证码
  verifySmsCodeByQuicksettlementApi,//校验短信验证码
  initApplyUnbindAliPayAccountByQuicksettlementApi,// 初始化解绑支付宝账号
  unbindAliPayAccountByQuicksettlementApi,// 解绑支付宝账号
} from '../../../api/quickIndemnity/quicksettlement';
export default {
  name: 'upAccount',
  mixins: [timeText],
  props: {
    upAccountInfo:{
      type: Object,
      default: {
        authCode:'', 
        mobile:'',
        active:'',
        haveNextVerifyMobileOperate:false,
        flag: 1
      }
    },
  },
  data() {
    return {
       timeText: '获取验证码',
       src: '',
       upAccountForm: {
        authCode:'',
        mobile: '',
        picSmsCode: '',
        smsCode: ''
      },
      upAccountFormRules: {
        mobile: [
          { required: false, message: '姓名不能为空', trigger: ['change', 'blur'] },
        ],
        picSmsCode: [
          { required: true, message: '图片验证码不能为空', trigger: ['change', 'blur'] },
        ],
        smsCode: [
          { required: true, message: '短信验证码不能为空', trigger: ['change', 'blur'] },
        ]
      },
      authCode:''
    };
  },
  watch: {
    upAccountInfo(val) {
      this.timeText = '获取验证码';
      this.$nextTick(()=>{
        this.upAccountForm.mobile = val.mobile
        this.refreshPic(val.authCode)
        console.log(3333333,val,this.upAccountInfo)
      })
    }
  },
  created(){
    // let time = Cookies.get('smsCode10');
    // if (time) {
    //   let showTime = 60 - parseInt((new Date().getTime() - new Date(time).getTime()) / 1000);
    //   this.timeText = showTime;
    //   this.setText();
    // }
    this.upAccountForm.mobile = this.upAccountInfo.mobile
    this.refreshPic(this.upAccountInfo.authCode)
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    close(){
      this.$nextTick(() => {
        this.$emit('close');
      })
    },
    // 获取图片验证码
    refreshPic(code) {
      getImageVerifyCodeByQuicksettlementApi(code).then(res => {
        // console.log(res.data.imageVerifyCode)
        if (res.data && res.data.imageVerifyCode) {
          this.src = res.data.imageVerifyCode;
        } else {
          this.$message.error('服务器返回内容有误！');
        }
      });
    },
    // 获取短信验证码
    sendSmsCode() {
      if (this.upAccountForm.picSmsCode === '') {
        this.$message({
          type: 'warning',
          message: '图片验证码不能为空'
        });
        return false;
      }
      this.authCode = '';
      getSmsCodeByQuicksettlementApi(this.upAccountForm.picSmsCode).then((res) => {
        if (res && (res.hasOwnProperty('error'))) {
          this.$message.error(res.error || '发送失败');
          this.refreshPic(this.upAccountInfo.authCode);
          this.upAccountForm.picSmsCode = '';
        } else {
          if(res && res.data){
            let info = JSON.parse(res.data);
            this.authCode = info.authCode;
          }
          let time = 60;
          // Cookies.set('smsCode10', new Date(), { expires: (1 / (24 * 60)) });
          this.timeText = time;
          this.setText();
        }
      });
    },
    // 校验短信验证码
    verifySmsCode(){
      if (this.upAccountForm.smsCode === '') {
        this.$message({
          type: 'warning',
          message: '短信验证码不能为空'
        });
        return false;
      }
      if(this.upAccountInfo.active == 'upAccount'){
        // 修改设置
        verifySmsCodeByQuicksettlementApi(this.upAccountForm.smsCode+'&authCode='+this.authCode).then(res => {
          if (res.status && res.status == 200) {
            let mobile = JSON.parse(res.data).mobile || '';
            if(mobile){
              // 二次跳转
              this.$nextTick(() => {
                this.$emit('next','upAccount',res.data,2);
                this.$refs['upAccountForm'].resetFields();
              });
            }else{
              // 一次跳转直接成功
              this.$nextTick(() => {
                this.$emit('next','upAccount',res.data,1);
                this.$refs['upAccountForm'].resetFields();
              });
            }
          } else {
            this.$message.error(res.error || '校验失败');
          }
        }).catch(() => {
          this.$message.error('校验失败');
        });
      }else{
        // 解绑
        verifySmsCodeByQuicksettlementApi(this.upAccountForm.smsCode+'&authCode='+this.authCode).then(res => {
          if (res.status && res.status == 200) {
            let authCode = JSON.parse(res.data).authCode || '';
            let mobile = JSON.parse(res.data).mobile || '';
            if(mobile){
              // 二次跳转
              this.$nextTick(() => {
                this.$emit('next','unBindAccount',res.data,2);
                this.$refs['upAccountForm'].resetFields();
              });
            }else{
              unbindAliPayAccountByQuicksettlementApi(authCode).then(res => {
                if (res.status && res.status == 200) {
                  // 一次跳转直接成功
                  this.$nextTick(() => {
                    this.$emit('next','unBindAccount',res.data,1);
                    this.$refs['upAccountForm'].resetFields();
                  });
                } else {
                  this.$message.error(res.error || '解绑失败');
                }
              }).catch(() => {
                this.$message.error('解绑失败');
              });
            }
          } else {
            this.$message.error(res.error || '校验失败');
          }
        }).catch(() => {
          this.$message.error('校验失败');
        });
      }
      console.log(this.upAccountInfo)
      
      
    },
    toApply(){
      initApplyUnbindAliPayAccountByQuicksettlementApi(this.upAccountInfo.authCode).then(res => {
        if (res.status && res.status == 200) {
          this.$nextTick(() => {
            let applyUnbindInfo = {
              authCode: this.upAccountInfo.authCode,
              data: res.data
            }
            this.$emit('next','upOrUnBindToApplyUnbind',applyUnbindInfo,1);
          })
        } else {
          this.$message.error(res.error || '校验失败');
        }
      }).catch(() => {
        this.$message.error('校验失败');
      });
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "../../../styles/variables";
#upAccount{
  .upAccount-form{
    .el-form-item--small.el-form-item{
      margin: 0 auto 18px auto;
    }
    .el-textarea{
      width: 440px;
    }
    .form-btn{
      display: block;
      margin-left: 0;
      margin-top: 40px!important;
      text-align: center;
    }
    .tip-style{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $blue-style;
      line-height: 32px;
    }
  }
}
</style>